import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'iban',
    standalone: false
})
export class IbanPipe implements PipeTransform {

  transform(value?: string): any {

    if (typeof value !== 'string') {
      return value;
    }

    return value.split(' ').join('').replace(/(.{4})/g, "$1 ");
  }

}
